var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5L4.125 4.125M9 3.9375V2.0625C12.8315 2.0625 15.9375 5.16852 15.9375 9C15.9375 12.8315 12.8315 15.9375 9 15.9375C5.16852 15.9375 2.0625 12.8315 2.0625 9C2.0625 7.92543 2.30681 6.90793 2.74291 6M11.0625 9C11.0625 10.1391 10.1391 11.0625 9 11.0625C7.86091 11.0625 6.9375 10.1391 6.9375 9C6.9375 7.86091 7.86091 6.9375 9 6.9375C10.1391 6.9375 11.0625 7.86091 11.0625 9Z",
    stroke: "#FF7926",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeter);
export default __webpack_public_path__ + "static/media/meter.743534ffd766c484d1d564034a597e00.svg";
export { ForwardRef as ReactComponent };